import { ISearchable } from './Searchable.itf'

/**
* @typedef  ProduitTransformeConstructor
* @type {object}
* @property {string} nom - the nom value
* @property {Object} idProduitTransforme - the idProduitTransforme value

* */
export class ProduitTransforme extends ISearchable {
  /**
   * Creates an instance of ProduitTransforme.
   * @memberof ProduitTransforme
   * */
  constructor(object) {
    super()
    this.nom = object.nom
    this.racc = object.racc
    this.composition = object.composition
    this.idProduitTransforme = object.idProduitTransforme
    this.fumaison = object.fumaison
    this.dlc = object.dlc
    this.salted = object.salted
    this.homemade = object.homemade
  }

  formatToDisplay() {
    this.nom = this.nom.charAt(0).toUpperCase() + this.nom.substring(1).toLowerCase()
    this.raccourci = this.racc
    this.lineClassName = 'transformLine'
    this.boxClassName = 'transformBox'
    this.displayType = 'Produit Transforme'
    this.created = true
    return this
  }

  formatToCreate() {
    this.formatToDisplay()
    this.created = false
    this.lineClassName = 'create-transformLine'
    return this
  }

  getIdAttribute() {
    return 'idProduitTransforme'
  }

  getNameAttribute() {
    return 'nom'
  }

  getRaccourciAttribute() {
    return 'raccourci'
  }
}
